execSelectionSetKeyArgs